import { PATHWAY } from "@/constants/testIds";
import { ADOPTION_STAGES } from "@/lib/pathwayData";
import { SectionEyebrow } from "@/components/pathway/Journey";

export default function AdoptionPath() {
  return (
    <section id="adoption" className="border-t hairline bg-[#0f0f0f]">
      <div className="mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-32">
        <div className="grid gap-8 md:grid-cols-[1.2fr_1fr] md:items-end md:gap-16">
          <div>
            <SectionEyebrow>Adoption path</SectionEyebrow>
            <h2 className="mt-4 font-serif text-3xl leading-tight tracking-tight text-neutral-50 sm:text-4xl lg:text-5xl">
              From one governed handoff to operational deployment.
            </h2>
          </div>
          <p className="text-neutral-400">
            KATLAS is evaluated as a capability, not procured as a consultancy
            engagement. The path moves from one proven handoff, to a department
            workflow, to a cross-organisational pilot, to live operational
            deployment.
          </p>
        </div>

        <ol className="mt-14 grid grid-cols-1 border-l hairline md:grid-cols-4">
          {ADOPTION_STAGES.map((s, i) => (
            <li
              key={s.slug}
              data-testid={PATHWAY.adoptionStage(s.slug)}
              className="relative flex flex-col border-b border-r hairline p-8 md:border-b-0 md:p-10"
            >
              <div className="font-mono text-[10px] uppercase tracking-[0.32em] text-amber-500">
                {s.eyebrow}
              </div>
              <h3 className="mt-4 font-serif text-xl leading-snug text-neutral-50">
                {s.title}
              </h3>
              <p className="mt-5 flex-1 text-[14px] leading-relaxed text-neutral-300">
                {s.body}
              </p>
              <div className="mt-8 border-t hairline pt-4">
                <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-neutral-500">
                  Deliverable
                </div>
                <div className="mt-1 font-mono text-[12px] text-neutral-200">
                  {s.deliverable}
                </div>
              </div>
              {/* Connector arrow on the right edge (md+) */}
              {i < 3 && (
                <span className="pointer-events-none absolute right-[-7px] top-1/2 hidden h-3 w-3 -translate-y-1/2 rotate-45 border-r border-t border-amber-700 md:block" />
              )}
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
